<mat-form-field [class]="fieldClass()" subscriptSizing="dynamic">
	<mat-label>{{ title() }}</mat-label>
	<mat-select multiple (selectionChange)="onSelectionChange($event.value)" [value]="currentValue()">
		@if (options().length > 0) {
			<mat-option (onSelectionChange)="onAllToggle($event)">
				<mat-pseudo-checkbox [state]="selectAllCheckboxState()"></mat-pseudo-checkbox>
				Select All
			</mat-option>
		}
		@for (parent of parents(); track parent.value) {
			<mat-option [value]="parent" (onSelectionChange)="onTypeToggle(parent.value, $event)">
				<mat-pseudo-checkbox [state]="typeCheckboxState(parent.value)"> </mat-pseudo-checkbox>
				{{ parent.display }}
			</mat-option>
			@for (location of itemsByParent()[parent.value]; track location.value) {
				<mat-option class="ps-5" [value]="location.value">
					{{ location.display }}
				</mat-option>
			}
		} @empty {
			<mat-option disabled>{{ emptyText() }}</mat-option>
		}
	</mat-select>
</mat-form-field>
